import { CatFieldNote } from '@blocks-react/components/FieldNote';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
type status = 'default' | 'success' | 'error' | 'warning';

export const ErrorFieldNote = ({
  error = '',
  className = '',
  status = 'error'
}: {
  className?: string;
  error: string;
  status?: status
}) => {
  return (
    <div className="d-flex my-2">
      <CatFieldNote status={status}>
        <div className={`me-2 ${className}`}>
          <CatIconWarningTriangle />
        </div>
        <span className={`u-fs--14 ${className}`}>{error}</span>
      </CatFieldNote>
    </div>
  );
};
